export enum CrudeModeEnum {
    VIEW,
    UPDATE,
    ADD = 2
}